import React from 'react'
import PropTypes from 'prop-types'

import { Box, Grid } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import { Card } from 'components'

const SkeletonForm = ({ isShow = false }) => {
  return (
    <Box display="flex" flexDirection="column" gridGap={24}>
      <Card title="Responsáveis">
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Skeleton variant="rect" height={56} />
          </Grid>
          <Grid item xs={12} md={6}>
            <Skeleton variant="rect" height={56} />
          </Grid>
          <Grid item xs={12}>
            <Skeleton variant="text" width="40%" height={32} />
          </Grid>
          {!isShow && (
            <>
              <Grid item xs={9} md={10}>
                <Skeleton variant="rect" height={56} />
              </Grid>
              <Grid item xs={3} md={2}>
                <Skeleton variant="rect" height={36} />
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <Skeleton variant="rect" height={150} />
          </Grid>
        </Grid>
      </Card>

      {!isShow && (
        <Card title="Questionários">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Skeleton variant="rect" height={300} />
            </Grid>
          </Grid>
        </Card>
      )}

      <Box display="flex" justifyContent="flex-end" gridGap={8}>
        <Skeleton variant="rect" width={120} height={36} />
        {!isShow && <Skeleton variant="rect" width={140} height={36} />}
      </Box>
    </Box>
  )
}

SkeletonForm.propTypes = {
  isShow: PropTypes.bool,
}

export default SkeletonForm
